import '@lottiefiles/lottie-player';
import LoadingLogo from 'assets/img/givebutter-loading.svg?react';
import * as elipseAnimation from 'assets/js/lotties/elipse-animation.json';
import { GradientCanvas } from 'components/gradient-canvas/GradientCanvas';

const LoadingScreen = () => {
  return (
    <>
      <GradientCanvas />
      <div className="flex h-full flex-col items-center">
        <div className="relative flex h-full flex-col items-center justify-center">
          <LoadingLogo />

          <lottie-player
            style={{
              width: '80px',
              height: '16px',
            }}
            autoplay
            loop
            src={JSON.stringify(elipseAnimation)}
          />
        </div>
      </div>
    </>
  );
};

export { LoadingScreen };
